import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsMentoringMixin extends Vue {
  get isMentoring() {
    return this.$store.getters.hasApiModuleMentoring;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isMentoringCheck.ts